<template>
  <!-- DOTS MENU -->
  <div
    :dir="isDesktop ? 'rtl' : 'ltr'"
    :style="isDesktop ? '' : 'top:56px;'"
    class="open-nav-dots shown"
  >
    <!-- RESCHED SURG BTN -->
    <div
      v-show="!isSelectedDatePassed"
      class="row flex flex--end block_action resched-btn"
    >
      <span class="resched-btn">שיבוץ מחדש</span>
      <div class="img-container">
        <img class="scheduling-svg" src="/assets/img/svg/scheduling.svg" />
      </div>
    </div>
    <!-- EDIT SURG BTN -->
    <div
      v-show="!isSelectedDatePassed"
      class="row flex flex--end block_action edit-btn"
    >
      <span class="edit-btn">עריכת ניתוח</span>
      <div class="img-container">
        <img class="scheduling-svg edit-btn" src="/assets/img/svg/clock.svg" />
      </div>
    </div>
    <!-- ADD SURG DOCS -->
    <div class="row flex flex--end block_action doc-btn">
      <span class="doc-btn">הוספת מסמכים</span>
      <div class="img-container">
        <img
          class="scheduling-svg doc-btn"
          src="/assets/img/svg/file-doc-blue.svg"
        />
      </div>
    </div>
    <!-- CELLOSIGN BTN -->
    <div v-if="showIVF" class="row flex flex--end block_action cellosign-btn">
      <span class="cellosign-btn">טפסי הסכמה</span>
      <div class="img-container">
        <img
          class="scheduling-svg cellosign-btn"
          src="/assets/img/svg/file-doc-blue.svg"
        />
      </div>
    </div>
    <!-- SEND SURG SPECIAL APPROVAL -->
    <div class="row flex flex--end block_action special-approval-btn">
      <span class="special-approval-btn">הגשה לוועדת חריגים</span>
      <div class="img-container">
        <img class="scheduling-svg" src="/assets/img/svg/file-doc-blue.svg" />
      </div>
    </div>
    <!-- SEND SMS BTN -->
    <div id="sms-line" class="row flex flex--end block_action sms-btn">
      <span id="sms-label" class="sms-btn">שליחת הודעה</span>
      <div class="img-container">
        <img class="scheduling-svg" src="/assets/img/svg/sms-blue.svg" />
      </div>
    </div>

    <div class="row flex flex--end block_action whatsapp-btn">
      <span class="whatsapp-btn">שליחת וואטסאפ</span>
      <div class="img-container">
        <img class="scheduling-svg" src="/assets/img/svg/wts-blue.svg" />
      </div>
    </div>
  </div>
  <!-- END DOTS MENU -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SurgMobileDotsMenu",
  props: ["event", "isSelectedDatePassed", "isDesktop"],
  computed: {
    ...mapGetters(["showIVF"])
  }
};
</script>
<style scoped>
.scheduling-svg {
  margin-left: 5px;
}
.img-container {
  display: flex;
  align-items: center;
}
#sms-label {
  margin: 0;
}
#sms-svg {
  width: 23px;
  height: 23px;
  margin-left: 10px;
  display: inline;
}
#sms-line {
  margin: 0;
}
</style>
